export default "__VITE_ASSET__CF4swuan__"